export default __webpack_public_path__ + "static/media/instructionsIcon.044fb711.svg";